module.exports = __webpack_public_path__ + "img/practiceLogoWeb_white-03.f4061917.png";